import { ReactComponent as NewIcon } from './new.svg';

export default NewIcon;
